import { render, staticRenderFns } from "./woAlarm.vue?vue&type=template&id=36de10fc&"
import script from "./woAlarm.vue?vue&type=script&lang=js&"
export * from "./woAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports